/**
 * DJB2 hash — deterministic string hashing for generating stable IDs.
 * Used across source fetchers for deduplication and ID generation.
 */
export function djb2Hash(str: string): string {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash + str.charCodeAt(i)) | 0;
  }
  return (hash >>> 0).toString(36);
}
